
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";;
export class DebitMemoService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.debit_Memo_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_DEBIT_MEMO_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }

  static lockDebitMemoNumber(input, responseCallBack, errorCallBack) {
    this.method("lockDebitMemoNumber", input, responseCallBack, errorCallBack);
  }

  static unLockDebitMemoNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockDebitMemoNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static initDebitMemoModule(input, responseCallBack, errorCallBack) {
    this.method("initDebitMemoModule", input, responseCallBack, errorCallBack);
  }

  static createDebitMemo(input, responseCallBack, errorCallBack) {
    this.method("createDebitMemo", input, responseCallBack, errorCallBack);
  }

  static readDebitMemo(input, responseCallBack, errorCallBack) {
    this.method("readDebitMemo", input, responseCallBack, errorCallBack);
  }

  static readDebitMemoDependencies(input, responseCallBack, errorCallBack) {
    this.method(
      "readDebitMemoDependencies",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static updateDebitMemo(input, responseCallBack, errorCallBack) {
    this.method("updateDebitMemo", input, responseCallBack, errorCallBack);
  }

  static getDebitMemoPageList(input, responseCallBack, errorCallBack) {
    this.method("getDebitMemoPageList", input, responseCallBack, errorCallBack);
  }

  static approveDebitMemo(input, responseCallBack, errorCallBack) {
    this.method("approveDebitMemo", input, responseCallBack, errorCallBack);
  }

  static cancelDebitMemo(input, responseCallBack, errorCallBack) {
    this.method("cancelDebitMemo", input, responseCallBack, errorCallBack);
  }

  static createAndApproveDebitMemo(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApproveDebitMemo",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static updateAndApproveDebitMemo(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApproveDebitMemo",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.debit_Memo_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.debit_Memo_data_url,responseCallBack, errorCallBack);
    }
  }
}
